<!-- 模板 -->
<template>
  <div class="" style="width: 100%">
    <div class="vision">
      <!-- <van-field
        readonly
        clickable
        label="右眼视力："
        :value="value"
        placeholder="选择城市"
        @click="visionShow = true"
      />
      <van-field
        readonly
        clickable
        label="右眼视力："
        :value="value"
        placeholder="选择城市"
        @click="visionShow = true"
      /> -->
      <div @click="openVision('left')">
        <span>左眼视力：</span>
        <div :class="['input', leftVision == '' ? 'input_a' : '']">
          {{ leftVision || "请选择左眼视力" }}
        </div>
      </div>
      <div @click="openVision('right')">
        <span>右眼视力：</span>
        <div :class="['input', rightVision == '' ? 'input_a' : '']">
          {{ rightVision || "请选择右眼视力" }}
        </div>
      </div>
    </div>
    <div class="btn btnFooter" @click="unclear">我不清楚</div>
    <div class="btnFooter" @click="next">下一步</div>
    <van-popup v-model="show" position="bottom">
      <van-picker
        show-toolbar
        :columns="columns"
        @cancel="show = false"
        @confirm="onConfirm"
      />
    </van-popup>
  </div>
</template>
<script>
// import request from '../utils/request.js'
import { Toast } from "vant-green";
export default {
  name: "vision",
  data() {
    return {
      type: "",
      leftVision: "",
      rightVision: "",
      // 视力
      show: false,
      columns: [
        "0.10",
        "0.12",
        "0.15",
        "0.20",
        "0.25",
        "0.30",
        "0.40",
        "0.50",
        "0.60",
        "0.80",
        "1.00",
        "1.20",
        "1.50",
        "2.00",
      ],
    };
  },
  props: [],
  methods: {
    next() {
      if (this.leftVision == "") {
        Toast.fail("请输入左眼视力");
        return;
      }
      if (this.rightVision == "") {
        Toast.fail("请输入右眼视力");
        return;
      }
      this.chang(this.leftVision, this.rightVision);
    },
    unclear() {
      this.chang(null, null);
    },
    chang(leftVision, rightVision) {
      console.log("222");
      this.$emit("change", {
        leftVision,
        rightVision,
      });
    },
    openVision(type) {
      this.type = type;
      this.show = true;
    },
    onConfirm(value, index) {
      console.log(`当前值：${value}, 当前索引：${index}`);
      if (this.type == "left") {
        this.leftVision = value;
      } else {
        this.rightVision = value;
      }
      this.show = false;
    },
  },
};
</script>
<style scoped>
.vision {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.vision > div {
  display: flex;
  align-items: center;
  background-color: #f6f7f5;
  margin: 2vh 0;
  padding: 5vw;
  border-radius: 40px;
  padding-left: 8vw;
  color: #121212;
  width: 100%;
  box-sizing: border-box;
}
.vision .input {
  background-color: #f6f7f5;
  border: none;
  flex: 1;
}
.vision .input_a {
  color: #a0a0a0;
}

.btnFooter {
  position: absolute;
  left: 50%;
  bottom: 10vh;
  transform: translate(-50%, 0%);

  width: 80vw;
  height: 11vw;
  border-radius: 5vw;
  text-align: center;
  line-height: 11vw;
  font-size: 4vw;
  background: rgb(41, 123, 255);
  color: white;
}
.btn {
  /* position: absolute;
  left: 50%;
  top: 80%; */
  /* transform: translate(-50%, 0%); */

  background: #f6f7f5;
  color: #242424;
  bottom: 20vh;
}
</style>
